"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomCountryOption = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var CustomCountryOption = exports.CustomCountryOption = function CustomCountryOption(optionProps) {
  var data = optionProps.data,
    innerProps = optionProps.innerProps,
    innerRef = optionProps.innerRef,
    isFocused = optionProps.isFocused;
  var name_ru = data.name_ru,
    visaAvailability = data.visaAvailability,
    countryNameRU = data.countryNameRU,
    kind = data.kind;
  var isCountry = kind.toLowerCase() === 'country';
  return /*#__PURE__*/_react["default"].createElement(StyledDestination, (0, _extends2["default"])({
    ref: innerRef
  }, innerProps, {
    isFocused: isFocused
  }), /*#__PURE__*/_react["default"].createElement(StyledDestinationName, null, name_ru, isCountry && /*#__PURE__*/_react["default"].createElement(Visa, null, visaAvailability)), !isCountry && /*#__PURE__*/_react["default"].createElement(CountryName, null, ", ".concat(countryNameRU)));
};
var StyledDestination = _styledComponents["default"].div.withConfig({
  displayName: "CustomCountryOption__StyledDestination",
  componentId: "sc-1t7rfqb-0"
})(["display:flex;align-items:center;padding:0 8px;border-top:1px solid ", ";width:100%;height:48px;font-size:14px;line-height:16px;background-color:", ";&:hover{cursor:pointer;background-color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.whiteLight;
}, function (_ref2) {
  var isFocused = _ref2.isFocused,
    theme = _ref2.theme;
  return isFocused && theme.colors.solitude;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.solitude;
});
var StyledDestinationName = _styledComponents["default"].div.withConfig({
  displayName: "CustomCountryOption__StyledDestinationName",
  componentId: "sc-1t7rfqb-1"
})(["display:flex;flex-direction:column;font-size:14px;line-height:16px;"]);
var Visa = _styledComponents["default"].div.withConfig({
  displayName: "CustomCountryOption__Visa",
  componentId: "sc-1t7rfqb-2"
})(["font-size:12px;line-height:16px;color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.greyLight;
});
var CountryName = _styledComponents["default"].div.withConfig({
  displayName: "CustomCountryOption__CountryName",
  componentId: "sc-1t7rfqb-3"
})(["color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.greyLight;
});